module.exports = __webpack_public_path__ + "media/customizations/sevenhills/logo-1ca01edc2d2342aea276d366c79d6d14.png";